module.exports = __webpack_public_path__ + "static/media/244-150.3b6aad3e.webp";